import React from "react";
import { WA_URL } from "../../config/links";

export default function WhatsAppFloat() {
    return (
        <a
            data-testid="whatsapp-float"
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Hubungi CS PUSATCUAN via WhatsApp"
            className="fixed bottom-20 right-4 md:bottom-24 md:right-6 z-[60] group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 blur-xl group-hover:opacity-70 transition-opacity animate-pulse" />
            <span className="relative flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white font-semibold shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="22"
                    height="22"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M20.52 3.48A11.76 11.76 0 0012.04 0C5.46 0 .09 5.37.09 11.95c0 2.1.55 4.16 1.6 5.97L0 24l6.25-1.64a11.94 11.94 0 005.78 1.48h.01c6.58 0 11.94-5.37 11.94-11.95 0-3.19-1.24-6.19-3.46-8.41zM12.04 21.8h-.01a9.83 9.83 0 01-5.01-1.37l-.36-.21-3.71.97.99-3.62-.23-.37a9.84 9.84 0 01-1.51-5.25c0-5.44 4.43-9.87 9.87-9.87 2.64 0 5.12 1.03 6.98 2.9a9.8 9.8 0 012.89 6.98c0 5.44-4.42 9.84-9.9 9.84zm5.41-7.37c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.91-2.2-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.5 1.69.63.71.22 1.35.19 1.86.12.57-.08 1.76-.72 2.01-1.42.25-.69.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z" />
                </svg>
                <span className="hidden sm:inline text-sm">Chat CS 24/7</span>
            </span>
        </a>
    );
}
